export default "<app-modal>\n  <app-question></app-question>\n</app-modal>"